import { APICONSTANTS } from '../../constants/api-constants';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ModeReglModel } from '../../models/simple-types/modeRegl.model';
import { HostnameService } from '../basic/hostname.service';
import { GenericLibelleService } from '../basic/generic-libelle.service';

@Injectable()
export class ModeReglService extends GenericLibelleService<ModeReglModel> {
    constructor(http: HttpClient,
                protected toastrService: ToastrService,
                protected hostnameService: HostnameService) {
        super(http, toastrService, APICONSTANTS.ROUTEMODEREGL, hostnameService);
  }
}
